var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_33011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4825 11.3378C8.51746 11.3233 8.55495 11.3158 8.5928 11.3158C8.63066 11.3159 8.66813 11.3234 8.70305 11.338C8.73798 11.3526 8.76968 11.374 8.79632 11.4008C8.82295 11.4277 8.844 11.4596 8.85826 11.4947C8.88738 11.5654 8.88735 11.6448 8.85816 11.7155C8.82897 11.7863 8.77299 11.8426 8.70244 11.8721L6.78657 12.6675L6.53232 14.0625H5.21382L5.35838 13.2604L4.581 13.5827C4.54605 13.5972 4.50856 13.6047 4.47071 13.6046C4.43285 13.6046 4.39538 13.5971 4.36046 13.5825C4.32553 13.5679 4.29383 13.5465 4.2672 13.5196C4.24056 13.4927 4.21951 13.4608 4.20525 13.4258C4.1763 13.3551 4.17643 13.2759 4.20561 13.2053C4.23479 13.1347 4.29066 13.0785 4.36107 13.0489L5.48044 12.5843L5.56482 12.1123L4.05338 12.7395C4.01845 12.7539 3.98102 12.7613 3.94323 12.7612C3.90544 12.7612 3.86803 12.7536 3.83317 12.739C3.79831 12.7244 3.76667 12.7031 3.74007 12.6763C3.71348 12.6494 3.69245 12.6176 3.67819 12.5826C3.64906 12.5118 3.6491 12.4325 3.67829 12.3617C3.70748 12.291 3.76346 12.2347 3.834 12.2051L5.68632 11.4362L7.03519 3.94315H10.845C13.1777 3.86271 14.3438 4.64177 14.3438 6.28033C14.3438 8.35877 12.8239 9.9664 10.2459 9.9664H7.27875L7.11957 10.8416L7.95601 10.4946C7.99093 10.4802 8.02837 10.4728 8.06616 10.4729C8.10395 10.4729 8.14135 10.4805 8.17621 10.4951C8.21108 10.5097 8.24272 10.531 8.26931 10.5578C8.29591 10.5847 8.31694 10.6165 8.33119 10.6515C8.36015 10.7222 8.36002 10.8014 8.33084 10.872C8.30166 10.9426 8.24579 10.9988 8.17538 11.0284L6.99582 11.5183L6.90975 11.9908L8.4825 11.3378ZM8.16188 5.12383L7.50263 8.7379H10.4378C12.2445 8.7379 12.9296 7.50883 12.9296 6.61727C12.9296 5.72627 12.4988 5.12383 11.061 5.12383H8.16188Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_33011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasl);
export default __webpack_public_path__ + "static/media/pasl.fe548438468857766b6c57247b7db95e.svg";
export { ForwardRef as ReactComponent };